<template>
  <div>
    <breadcrumb :routerList="[{to:'/chanp/companyPriceManage',title:'价格管理(客户)'},{title:'公司定价信息'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine weekplandetail14">
                    <el-form :model="zy" label-position="right" ref="zy" :inline="true"   class="demo-ruleForm h-formbLine h-formbLine1">

                        <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                            <el-input v-model="zy.agentName" placeholder="请输入" readonly>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                            <el-input placeholder="选择经销商自动带出" v-model="zy.agentCode" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="销售区域" class="h-elformWrap-2" prop="salesregionName">
                            <el-input placeholder="选择经销商自动带出" v-model="zy.salesregionName" readonly></el-input>
                        </el-form-item>

                        <el-form-item label="直单附件" class="h-elformWrap-2" prop="upload" v-if="!isHsjOrKs">
                            <brupload
                                :refid="zy.fileid"
                                reftype="代理商注册-附件"
                                :showtime="false">
                            </brupload>
                        </el-form-item>

                        <el-form-item label="附件" class="h-elformWrap-2" prop="upload1" v-if="!isHsjOrKs">
                            <brupload
                                :refid="zy.kehufujian"
                                reftype="客户定价-附件"
                                :showtime="false">
                            </brupload>
                        </el-form-item>


                    </el-form>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;" v-if="isOemProduct">
            <div class="h-rowCon" style="padding-bottom:0">
              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                  <h1>采购价格</h1>
                </div>
              </div>
              <el-table
                  ref="multipleTable"
                  :data="oemTableData"
                  stripe
                  style="width: 100%"
                  :border="true">
                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="productName"
                    label="产品型号">
                </el-table-column>
                <el-table-column
                    prop="productId"
                    label="产品编码">
                </el-table-column>
                <el-table-column
                    prop="unitPrice"
                    label="采购价格">
                </el-table-column>
                <el-table-column
                    prop="currency"
                    label="币种">
                  <template slot-scope="scope">
                    {{scope.row.currency | dictname('YLCurrency')}}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="customerCode"
                    label="供应商编码">
                </el-table-column>
                <el-table-column
                    prop="customerName"
                    label="供应商名称">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
            <div class="h-rowCon" style="padding-bottom:0">
              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                  <h1>定价信息</h1>
                </div>
              </div>
              <el-table
                  ref="multipleTable"
                  @selection-change="handleSelectionChange"
                  :data="tableData3"
                  stripe
                  style="width: 100%"
                  :border="true">
                <el-table-column
                    type="selection"
                    width="40"
                    :label="all">
                </el-table-column>
                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="leltypecode"
                    label="定价类型"
                    width="100">
                  <template slot-scope="scope">
                    <el-select class="h-tableInput"   v-model="scope.row.leltypecode" placeholder="请选择"
                                 style="width: 100%;">
                        <el-option  v-for="(item) in dingjialeixing"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                           >
                        </el-option>
                      </el-select>
                  </template>
                </el-table-column>
                  <el-table-column
                      prop="materialCode"
                      label="物料编码"
                      :show-overflow-tooltip="true"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="materialDescrition"
                      label="物料名称"
                      :show-overflow-tooltip="true"
                      width="180">
                  </el-table-column>


                <el-table-column
                    prop="currency"
                    label="币种"
                    min-width="160">
                  <template slot-scope="scope">
                    <el-select class="h-tableInput" v-model="scope.row.currency" style="width:100%"
                               :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
                               :class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
                               filterable>
                      <el-option v-for="item in bizhongListops" :key="item.code"
                                 :label="item.name" :value="item.code"
                                 :disabled="true">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="价格"
                    width="100">
                  <template slot-scope="scope">
                      <el-input class="h-tableInput" v-model="scope.row.value" placeholder="" type="number"
                                :disabled="scope.row.ispass==1||scope.row.ispass==3"></el-input>

                  </template>
                </el-table-column>


                <el-table-column
                    prop="prodseries"
                    label="大类名称"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="startdate"
                    label="有效开始时间"
                    width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ispass==1||scope.row.ispass==3">
                      {{scope.row.startdate}}
                    </div>
                    <div v-else>
                      <el-date-picker
                          class="h-tableInput"
                          v-model="scope.row.startdate"
                          style="width: 100%;"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="开始日期"
                          @change="dateChange1(scope.row)">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="effectivedate"
                    label="有效结束时间"
                    width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ispass==1||scope.row.ispass==3">
                      {{scope.row.effectivedate}}
                    </div>
                    <div v-else>
                      <el-date-picker
                          class="h-tableInput"
                          v-model="scope.row.effectivedate"
                          style="width: 100%;"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="结束日期"
                          @change="dateChange2(scope.row)">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>

              </el-table>

            </div>
          </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>

      </div>
      <div class="h-txtCenter h-mrt60">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../api/SystemService'
import shoudf from "@/components/dialog/selectshdf.vue";
export default {
  components: {shoudf},
  data() {
    let that = this
    return {
      LevelName: [],
      //批量导入
      uploaddownexcelflag: false,
      isOemPrice: true,
      isOemProduct: false,
      //区域list
      YlSalesAreawaioxiaolist: [],

      //币种
      bizhongListops: [],

      chongxintijiaoshow: false,
      //ywid
      ywid: null,
      //instid
      instid: null,
      showinstid: null,
      showhistory: false,
      //taskid
      taskid: null,
      YLCurrencyList: [],
      fanhuizancun: [],
      bianlianga: '',

      //查询定价集合
      dingjiajihe: [],
      q: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //币种
      bizhonglist: [],
      //区域
      YlSalesArea: [],
      //前页转发内容
      chanpinneirong: {},
      //定价id
      dingjiaid: '',
      dingjialeixing: [
        {
          value: 2,
          label: '外贸',
          disabled: true
        }, {
          value: 1,
          label: '内销'
        }, {
          value: 0,
          label: '外销',
          disabled: true
        }],
      jibie: [{
        value: '',
        label: '--请选择--'
      },],
      quyu: [{
        value: '',
        label: '--请选择--'
      },],
      //配置集合
      configlist: {},
      bizhongop: [{
        value: '',
        label: '--请选择--'
      },],
      all: "全部",
      formInline: {
        names: '',
        starttime: '',
        endtime: '',
        areaName: ''
      },
      day1:'',
      day2:'',
      options2: [],
      zy: {

      },
      tableData3: [],
      delIds: [],

      oemTableData: [],
      optionsCustomer: [],
      optionsAgent: [],
      userCarePlan: {},

      showshdfdialog: false,
      ddlx:'1,2',
      sceneList:[],//场景

      isHsjOrKs: false, //物料是海盛杰或者康盛
    }
  },
  mounted() {
  },
  created() {
    this.showLevelName();



    this.bizhongjiazai();

    this.options2 = this.$store.getters.dicts["userCareType"];

    if (this.$route.query) {

        //前页信息
        this.chanpinneirong = this.$router.history.current.query;
        //物料号
        this.dingjiaid = this.$router.history.current.query.materialCode;
        //上头内容
        this.zy = this.$router.history.current.query;


        this.query(this.$router.history.current.query);

    }
  },
  beforeRouteLeave(to,from,next){
    if(to.path=='/chanp/companyPriceManage' && from.path == '/chanp/companyPriceOnlyRead'){
      to.meta.keepAlive = true;
    }else{
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    //查看进度
    chakanjindu(q){
      this.showinstid = q;
      this.showhistory = true;
    },
    changeType(v) {
      if (v == '自产') {
        //如果型号属性修改为自产 则将采购价格限制去除
        this.isOemPrice = true;
        //将采购价格表格隐藏
        this.isOemProduct = false;
      } else {
        //若是OEM则将采购价格表格显示
        this.isOemProduct = true;

      }
    },

    dateChange1(val) {
      var dd = val.startdate;
      dd = dd.replace(/-/g, '/')
      var date =  new Date(dd);
      this.day1 = date.getTime();
      if (this.day2 < this.day1) {
        if (this.day2 == 0) {
          return;
        }
        this.$msg.msge("结束日期不能在开始日期之前");
        val.startdate = "";
      }
    },
    dateChange2(val) {
      var tt = val.effectivedate;
      tt = tt.replace(/-/g, '/')
      var date = new Date(tt);
      this.day2 = date.getTime()
      if (this.day2 < this.day1) {
        this.$msg.msge("结束日期不能在开始日期之前");
        val.effectivedate = "";
      }
    },
    //币种加载
    bizhongjiazai() {
      ss.Dictservice.listbycategory("YLCurrency").then(rd => {
        this.bizhongListops = rd;
      })
    },


    query(q) {
    //如果id不为空
      console.log("qqqqqq",q)
      if(q.instid){
        ss.companyPrice.selectByBanben(q.shenpibanben).then(rd => {
          if(rd.f){
            this.tableData3 = rd.obj;
              //如果是海盛杰或者康盛的产品
              if(rd.obj[0].noHsjKs){
                  this.isHsjOrKs = false;
              }else{
                  this.isHsjOrKs = true;

              }
          }

        });
      }

    },


    //取消
    quxiao() {
      //this.$router.go(-1);
      this.$router.push({path: '/chanp/companyPriceManage'});

    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },


    //产品大类
    showLevelName() {
      ss.UserDemand.showLevelName().then(rd => {
        this.LevelName = rd;
      })
    },


  },
}
</script>
<style>

.weekplandetail14 .h-formbLine .el-form-item__label {
  width: 35%;
  text-align: right;
}

.weekplandetail14 .h-formbLine .el-form-item__content {
  width: 65%;
}

.weekplandetail14 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
.ljjtablepaddings12 .h-tableInput .el-input__inner{
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings12 .h-tableInput .el-input__icon{
  line-height: 0.25rem;
}

.ljj_selectdisblednone .el-input.is-disabled .el-input__inner{
  border-color: transparent;
}
.ljj_selectdisblednone.el-select .el-input.is-disabled .el-input__inner:hover{
  border-color: transparent;
}
.ljj_selectdisblednone .el-input__suffix{
  display: none;
}
</style>



